/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pt-select-group-pro.vue?vue&type=template&id=2cf848e5&"
import script from "./pt-select-group-pro.vue?vue&type=script&lang=ts&"
export * from "./pt-select-group-pro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports